import { TextArea } from 'components/shared/TextField/TextArea';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

type OwnProps = {
  value: string;
  className?: string;
  disabled?: boolean;
  isLoading: boolean;
  onChange: (newComment: string) => void;
};
export const Comment: FC<OwnProps> = ({ value, className, disabled, isLoading, onChange }) => (
  <div className={className}>
    {isLoading && <Skeleton height="14em" />}
    {!isLoading && (
      <TextArea
        className="form-control"
        e2e="fightback-comment"
        value={value}
        disabled={disabled}
        onValueChanged={onChange}
        placeholder="Please input a comment"
        rows={10}
      />
    )}
  </div>
);
